import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_service checks is_active + name + price > 0.
// Template services with valid prices now count. services_customized
// distinguishes seeded templates from user-authored services.
export async function resolveServicesItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_service) {
    const reason = progress.services_customized ? 'services configured' : 'seeded';
    return { complete: true, reason };
  }
  return { complete: false, reason: 'no active priced services' };
}
